import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemTypeOfOrganizationLevel extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          {this.props.item.ten}
        </td>
        <td>
          {this.props.item.moTa}
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('LOAICOQUANQUANLY_SUA') ?
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}
                >
                  Chỉnh sửa
                </Link>
              : null
            }
            {
              CheckPermission('LOAICOQUANQUANLY_XOA') ?
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.loaiCoQuanQuanLyId}
                />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemTypeOfOrganizationLevel.jsx